// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file no/jotta/openapi/device/v2/device.v2.proto (package no.jotta.openapi.device.v2, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MethodKind } from "@bufbuild/protobuf";
import { CreateRequest, CreateResponse, DeleteRequest, DeleteResponse, GetRequest, GetResponse, ListRequest, ListResponse, MatchRequest, MatchResponse, ModifyRequest, ModifyResponse } from "./device.v2_pb.js";
import { PingRequest, PingResponse } from "../../ping_pb.js";
/**
 * Create creates a new backup device.
 * To check if there is already a similar device, you must check the results from Match call.
 *
 * @generated from rpc no.jotta.openapi.device.v2.DeviceService.Create
 */
export const create = {
    localName: "create",
    name: "Create",
    kind: MethodKind.Unary,
    I: CreateRequest,
    O: CreateResponse,
    service: {
        typeName: "no.jotta.openapi.device.v2.DeviceService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.device.v2.DeviceService.Get
 */
export const get = {
    localName: "get",
    name: "Get",
    kind: MethodKind.Unary,
    I: GetRequest,
    O: GetResponse,
    service: {
        typeName: "no.jotta.openapi.device.v2.DeviceService"
    }
};
/**
 * Match tries to find existing backup devices that match the requested parameters.
 * Use this to display a list of possible backup devices to the customer during initial device setup.
 *
 * @generated from rpc no.jotta.openapi.device.v2.DeviceService.Match
 */
export const match = {
    localName: "match",
    name: "Match",
    kind: MethodKind.Unary,
    I: MatchRequest,
    O: MatchResponse,
    service: {
        typeName: "no.jotta.openapi.device.v2.DeviceService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.device.v2.DeviceService.List
 */
export const list = {
    localName: "list",
    name: "List",
    kind: MethodKind.Unary,
    I: ListRequest,
    O: ListResponse,
    service: {
        typeName: "no.jotta.openapi.device.v2.DeviceService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.device.v2.DeviceService.Modify
 */
export const modify = {
    localName: "modify",
    name: "Modify",
    kind: MethodKind.Unary,
    I: ModifyRequest,
    O: ModifyResponse,
    service: {
        typeName: "no.jotta.openapi.device.v2.DeviceService"
    }
};
/**
 * @generated from rpc no.jotta.openapi.device.v2.DeviceService.Delete
 */
export const delete$ = {
    localName: "delete",
    name: "Delete",
    kind: MethodKind.Unary,
    I: DeleteRequest,
    O: DeleteResponse,
    service: {
        typeName: "no.jotta.openapi.device.v2.DeviceService"
    }
};
/**
 * Safe noop for testing purposes
 *
 * @generated from rpc no.jotta.openapi.device.v2.DeviceService.Ping
 */
export const ping = {
    localName: "ping",
    name: "Ping",
    kind: MethodKind.Unary,
    I: PingRequest,
    O: PingResponse,
    service: {
        typeName: "no.jotta.openapi.device.v2.DeviceService"
    }
};
